import {AddressTypeV4Enum} from 'domain/usecases';
import {
	makePostBeneficiaryAddressV4,
	makePostBeneficiaryAddressSuggestionV4,
} from 'main/factories/usecases';
import {
	favoritePlaceToAddressV4Item,
	favoritePlaceToAddressSuggestionV4Payload,
} from '../../utils/addressV4Payload';
import {PostAssignFavoriteAddressToDependentsParams} from './types';

export async function postAssignFavoriteAddressToDependents({
	item,
	selected,
	signal,
}: PostAssignFavoriteAddressToDependentsParams): Promise<void> {
	const minorCodes = selected.filter(d => d.idadeC < 18).map(d => d.cdPessoaC.toString());
	const adultCodes = selected.filter(d => d.idadeC >= 18).map(d => d.cdPessoaC.toString());

	if (minorCodes.length > 0) {
		const baseAddressItem = favoritePlaceToAddressV4Item(item.address, minorCodes);
		const {descriptionOthers: _discarded, ...addressWithoutOthers} = baseAddressItem;
		const addressItem = {...addressWithoutOthers, type: AddressTypeV4Enum.RESIDENTIAL};
		await makePostBeneficiaryAddressV4().post({addresses: [addressItem], signal});
	}

	if (adultCodes.length > 0) {
		const suggestionPayload = favoritePlaceToAddressSuggestionV4Payload(
			item.address,
			adultCodes,
		);
		await makePostBeneficiaryAddressSuggestionV4().post({...suggestionPayload, signal});
	}
}
